import React, { useState } from "react";
import BackButton from "../components/BackButton";
import { API_URL } from "../config";

function HelpSupport() {
  const [subject, setSubject] = useState("Deposit Issue");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null); // Base64 Image
  const [fileName, setFileName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null); 

  const token = localStorage.getItem("token");

  // Toggle Logic for Accordion
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  // Convert Image to Base64 (Aasan tarika JSON mein image bhejne ka)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) { // 2MB limit
        alert("File size must be less than 2MB");
        return;
      }
      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setAttachment(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Submit Ticket Logic
  const handleSubmit = async () => {
    if (!description.trim()) {
        return alert("Please describe your issue.");
    }

    setIsSubmitting(true);
    try {
        const res = await fetch(`${API_URL}/api/tickets/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ 
                subject, 
                description, 
                attachment 
            })
        });

        const data = await res.json();

        if (data.success) {
            setSubmitted(true);
            setSubject("Deposit Issue");
            setDescription("");
            setAttachment(null);
            setFileName("");
            
            // 3 second baad success message hata do
            setTimeout(() => setSubmitted(false), 3000);
        } else {
            alert(data.message || "Failed to raise ticket");
        }
    } catch (error) {
        alert("Network Error! Please try again later.");
        console.error(error);
    } finally {
        setIsSubmitting(false);
    }
  };

  const faqs = [
    {
      question: "How do I withdraw my winnings?",
      answer: "Go to Wallet → Withdraw → Enter amount → Submit. Withdrawals are processed within 24 hours to your registered bank account."
    },
    {
      question: "What is the minimum team size?",
      answer: "You must select exactly 11 players for your team. This includes 1 Captain and 1 Vice Captain."
    },
    {
      question: "Can I change my team after match starts?",
      answer: "No, teams are locked once the match begins. Create your team before the match start time."
    },
    {
      question: "How are prizes distributed?",
      answer: "Prizes are distributed to top-ranked players based on total points. Check contest details for prize pool breakdown."
    },
    {
      question: "What if there's a tie?",
      answer: "In case of a tie, prize is split equally among tied players. Fractional amounts are credited to accounts."
    }
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#f8f9fc", paddingBottom: "100px", fontFamily: "'Poppins', sans-serif" }}>
      
      {/* === HEADER SECTION (Premium Maroon Theme) === */}
      <div 
        className="pb-5 pt-2 position-relative"
        style={{ 
            background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", 
            borderBottomLeftRadius: "40px", 
            borderBottomRightRadius: "40px",
            boxShadow: "0 10px 20px rgba(128,0,0,0.2)"
        }}
      >
        <div className="container-fluid px-3">
          <BackButton to="/home" label="" className="text-white" />
          
          <div className="text-center text-white mt-2 mb-4">
            <p className="fw-bolder h2 mb-1" style={{ letterSpacing: "1px" }}>Help & Support</p>
            <p className="opacity-75 fw-semibold mb-4 small">We are here to help you 24/7.</p>
          </div>
        </div>
      </div>

      <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-40px" }}>
        
        {/* === QUICK SUPPORT CHANNELS (Only Email) === */}
        <div className="card border-0 shadow-lg mb-4 animate-up" style={{ borderRadius: "20px" }}>
            <div className="card-body p-4 text-center">
                <div className="bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                    <i className="bi bi-envelope-paper-heart-fill text-danger fs-3"></i>
                </div>
                <h5 className="fw-bold text-dark mb-1">Email Support</h5>
                <p className="text-muted small mb-3">Drop us an email and we'll reply within 24 hours.</p>
                <a href="mailto:support.win11pro@gmail.com" className="btn btn-outline-danger rounded-pill px-4 fw-bold">
                    <i className="bi bi-envelope-fill me-2"></i> Win11 Support
                </a>
            </div>
        </div>

        {/* === TICKET FORM (Enhanced) === */}
        <div className="card border-0 shadow-sm mb-4 animate-up" style={{ borderRadius: "20px" }}>
            <div className="card-body p-4">
                <h6 className="fw-bold text-dark mb-4 border-bottom pb-2">
                    <i className="bi bi-ticket-detailed-fill me-2" style={{ color: "#800000" }}></i>
                    Raise a Ticket
                </h6>
                
                {!submitted ? (
                    <>
                        {/* 1. Subject Dropdown */}
                        <div className="mb-3">
                            <label className="form-label text-muted small fw-bold">SELECT ISSUE TYPE</label>
                            <select 
                                className="form-select bg-light border-0 py-2" 
                                style={{ borderRadius: "12px", boxShadow: "none", cursor: "pointer" }}
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            >
                                <option value="Deposit Issue">Deposit Issue</option>
                                <option value="Withdrawal Issue">Withdrawal Issue</option>
                                <option value="KYC Verification">KYC Verification</option>
                                <option value="Game Play / Contest">Game Play / Contest</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        {/* 2. Description Textarea */}
                        <div className="mb-3">
                            <label className="form-label text-muted small fw-bold">DESCRIBE YOUR ISSUE</label>
                            <textarea
                                className="form-control bg-light border-0 p-3"
                                rows="4"
                                placeholder="Please explain your issue in detail..."
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                style={{ borderRadius: "12px", resize: "none", boxShadow: "none" }}
                            ></textarea>
                        </div>

                        {/* 3. Upload Screenshot */}
                        <div className="mb-4">
                            <label className="form-label text-muted small fw-bold">UPLOAD SCREENSHOT (OPTIONAL)</label>
                            <div className="d-flex align-items-center">
                                <label className="btn btn-light border-0 text-primary fw-bold shadow-sm" style={{ borderRadius: "10px", cursor: "pointer" }}>
                                    <i className="bi bi-cloud-arrow-up-fill me-2"></i> Choose File
                                    <input type="file" className="d-none" accept="image/*" onChange={handleFileChange} />
                                </label>
                                {fileName && <span className="ms-3 small text-success fw-bold text-truncate" style={{ maxWidth: "150px" }}><i className="bi bi-check-circle-fill me-1"></i> {fileName}</span>}
                            </div>
                        </div>

                        {/* 4. Submit Button */}
                        <button
                            className="btn w-100 py-3 rounded-pill fw-bold text-white shadow-sm hover-scale"
                            onClick={handleSubmit}
                            disabled={!description.trim() || isSubmitting}
                            style={{ background: isSubmitting ? "#ccc" : "linear-gradient(135deg, #800000 0%, #4A0000 100%)", border: "none" }}
                        >
                            {isSubmitting ? (
                                <><span className="spinner-border spinner-border-sm me-2"></span> Submitting...</>
                            ) : (
                                <>Send Ticket <i className="bi bi-send-fill ms-2"></i></>
                            )}
                        </button>
                    </>
                ) : (
                    <div className="text-center py-4 animate-up">
                        <div className="mb-3 text-success animate-bounce">
                            <i className="bi bi-check-circle-fill display-1"></i>
                        </div>
                        <h5 className="fw-bold">Ticket Raised Successfully!</h5>
                        <p className="text-muted small">We have sent a confirmation email. Our team will get back to you soon.</p>
                        <button className="btn btn-outline-dark btn-sm rounded-pill mt-3 px-4" onClick={() => setSubmitted(false)}>
                            Raise another issue
                        </button>
                    </div>
                )}
            </div>
        </div>

        {/* === FAQ ACCORDION === */}
        <div className="mb-4 animate-up" style={{ animationDelay: "0.2s" }}>
            <h6 className="fw-bold text-dark mb-3 px-1">Frequently Asked Questions</h6>
            <div className="d-flex flex-column gap-3">
                {faqs.map((faq, idx) => {
                    const isOpen = activeAccordion === idx;
                    return (
                        <div 
                            key={idx} 
                            className="card border-0 shadow-sm" 
                            style={{ borderRadius: "15px", overflow: "hidden" }}
                        >
                            <div 
                                className="card-header bg-white border-0 p-3 d-flex justify-content-between align-items-center"
                                onClick={() => toggleAccordion(idx)}
                                style={{ cursor: "pointer" }}
                            >
                                <span className={`fw-bold ${isOpen ? "maroon-text" : "text-dark"}`} style={{ fontSize: "0.95rem" }}>
                                    {faq.question}
                                </span>
                                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ background: isOpen ? "#ffe6e6" : "#f8f9fa", width: "30px", height: "30px" }}>
                                    <i className={`bi bi-chevron-down transition-icon ${isOpen ? "rotate-180 maroon-text" : "text-muted"}`} 
                                       style={{ transition: "transform 0.3s", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}></i>
                                </div>
                            </div>
                            
                            {/* Animated Body */}
                            <div style={{ 
                                maxHeight: isOpen ? "200px" : "0px", 
                                overflow: "hidden", 
                                transition: "max-height 0.3s ease-out",
                                background: "#fafbfc"
                            }}>
                                <div className="p-3 pt-0 text-muted small" style={{ lineHeight: "1.6" }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>

      </div>

      {/* --- CUSTOM CSS --- */}
      <style>{`
        .maroon-text { color: #800000; }
        .hover-scale:active { transform: scale(0.98); transition: 0.2s; }
        .animate-up { animation: fadeInUp 0.5s ease-out both; }
        .animate-bounce { animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) both; }
        
        @keyframes fadeInUp { 
            from { opacity: 0; transform: translateY(20px); } 
            to { opacity: 1; transform: translateY(0); } 
        }
        @keyframes bounceIn {
            0% { transform: scale(0); opacity: 0; }
            50% { transform: scale(1.2); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
        }
      `}</style>

    </div>
  );
}

export default HelpSupport;